import { render } from "./OperationWay.vue?vue&type=template&id=002c9760&scoped=true"
import script from "./OperationWay.vue?vue&type=script&lang=js"
export * from "./OperationWay.vue?vue&type=script&lang=js"

import "./OperationWay.vue?vue&type=style&index=0&id=002c9760&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002c9760"]])

export default __exports__